'use client';

import { navHome, rdNavProviders, rdNavSeekers } from 'Workadabra/translations';
import { NavDock, type NavDockItem } from '@bomdisoft/components';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export const WorkadabraNavDock = () => {
  const params = useParams();
  const langPrefix = typeof params.lang === 'string' ? params.lang : 'en';
  const language = getLanguageFromLocale(langPrefix);

  const items: NavDockItem[] = [
    { exact: true, href: `/${langPrefix}`, label: navHome[language], matchPaths: [`/${langPrefix}`], testId: 'nav-link-home' },
    { href: `/${langPrefix}/providers`, label: rdNavProviders[language], matchPaths: [`/${langPrefix}/providers`], testId: 'nav-link-providers' },
    { href: `/${langPrefix}/seekers`, label: rdNavSeekers[language], matchPaths: [`/${langPrefix}/seekers`], testId: 'nav-link-seekers' },
  ];

  return <NavDock items={items} testId='main-nav-dock' />;
};
